import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as BenefitsTypesActions, Selectors as BenefitsTypesSelectors } from 'store/ducks/benefitsTypes';

import { Access } from 'common';
import { Form, Loading } from 'components';

class CustomForm extends Component {
  static defaultProps = {
    edit: false,
  };

  state = {
    data: this.props.data,
    edit: false,
  };

  componentDidMount() {
    const { getBenefitsTypesPlansRequest } = this.props;

    getBenefitsTypesPlansRequest();
  }

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { loading, onChange } = this.props;

    if (oldProps.loading && !loading && oldProps.data !== this.props.data) {
      this.setState({
        data: {
          ...this.props.data,
        },
        edit: this.props.data.id !== '',
      });
    }

    if (oldState.data !== data) {
      onChange(data);
    }
  }

  handleChangeInput = e => {
    const { data } = this.state;
    const { name, value } = e.target;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleChangeExtraDataInput = e => {
    const { data } = this.state;
    const { name, value } = e.target;

    this.setState({ data: { ...data, extra_data: { ...data.extra_data, [name]: value } } });
  };

  handleChangeCheckbox = name => {
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: !data[name] } });
  };

  handleChangeExtraDataCheckbox = name => {
    const { data } = this.state;

    this.setState({ data: { ...data, extra_data: { ...data.extra_data, [name]: !data.extra_data[name] } } });
  };

  handleSelectPlans = experience_plan_ids => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        extra_data: {
          ...data.extra_data,
          experience_plan_ids,
        },
      },
    });
  };

  handleToggle = (name) => {
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: !data[name] } });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { onSave } = this.props;

    onSave();
  };

  render() {
    const { data } = this.state;
    const { errors, saving } = this.props;

    return (
      <Form className="page-form" onSubmit={this.handleSubmit}>
        <h3 className="form-title">Detalhes da Campanha Comercial</h3>
        <Form.Field>
          <Form.Label>Título</Form.Label>
          <Form.Input
            name="title"
            placeholder="Digite o título da campanha"
            value={data.title}
            onChange={this.handleChangeInput}
            errors={errors.title}
          />
        </Form.Field>

        <Form.Field>
          <Form.Label>Descrição</Form.Label>
          <Form.TextArea
            name="description"
            placeholder="Descrição da campanha"
            value={data.description}
            onChange={this.handleChangeInput}
            errors={errors.description}
          />
        </Form.Field>

        <Form.Field className="checkbox-field">
          <Form.Label>Ativo</Form.Label>
          <Form.Checkbox
            checked={data.status_value}
            onChange={() => this.handleToggle("status_value")}
          />
        </Form.Field>

        <div className="buttons">
          <Link to="/benefits/campaign/list" className="button-cancel">
            Cancelar
          </Link>
          {Access.hasPermissions("edit-benefits") && (
            <Form.Button
              className="button-save"
              onClick={this.handleSubmit}
              disabled={saving}
            >
              {saving ? (
                <Loading type="btn" size="small" text="Salvando..." />
              ) : (
                "Salvar"
              )}
            </Form.Button>
          )}
        </div>
      </Form>
    );
  }
}

const mapState = state => ({
  plans: {
    ...state.benefitsTypes.plans,
    data: BenefitsTypesSelectors.plans(state.benefitsTypes.plans.data),
  },
});

const mapActions = dispatch => bindActionCreators(BenefitsTypesActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(CustomForm);
